import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=68d61a3c&scoped=true"
import script from "./ActionsMenu.vue?vue&type=script&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./ActionsMenu.vue?vue&type=style&index=0&id=68d61a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d61a3c",
  null
  
)

export default component.exports